import React from "react";
import StarRating from "./StarRating";

/** Confirmation after a survey: "Thank you" + the per-question analysis. */
const SurveyDone = ({ result, onDone, doneLabel = "Back to surveys" }) => {
  const analysis = result?.analysis || {};
  const ratings = Array.isArray(analysis.ratings) ? analysis.ratings : [];
  return (
    <div className="fb_card fb_done">
      <div className="fb_done_icon" aria-hidden="true">
        ✓
      </div>
      <h2 className="fb_survey_title">Thank you</h2>
      <p className="fb_muted">
        {result?.message || "Your feedback has been recorded."}
      </p>
      {typeof analysis.overall === "number" ? (
        <div className="fb_overall">
          <span className="fb_overall_score">
            {analysis.overall.toFixed(1)}
          </span>
          <span className="fb_overall_label">/ 5 overall</span>
        </div>
      ) : null}
      {ratings.length > 0 ? (
        <ul className="fb_analysis_list" aria-label="Your ratings">
          {ratings.map((r) => (
            <li key={r.key} className="fb_analysis_row">
              <span className="fb_analysis_text">{r.text}</span>
              <span className="fb_analysis_rating">
                <StarRating value={r.rating} size={18} />
                <span>{r.rating}/5</span>
              </span>
            </li>
          ))}
        </ul>
      ) : null}
      <button type="button" className="fb_btn_primary" onClick={onDone}>
        {doneLabel}
      </button>
    </div>
  );
};

export default SurveyDone;
